import { useDispatch } from "react-redux";
import {
  loadUserPreferences,
  saveUserPreferences,
  saveValetRequestMonitor,
} from "../../state/slices/UserPreferences/userPreferences";
import {
  setLocalStorage,
  getLocalStorage,
} from "../../utils/localStorage/LocalStorageService";
import { USER_PREFERENCES_KEY_PREFIX, DEFAULT_THEME } from "../../constants";

export const useUserPreferences = () => {
  const dispatch = useDispatch();

  const loadPreferences = (userID) => {
    if (!userID) {
      dispatch(loadUserPreferences({ preferences: null }));
      return;
    }
    const userPrefsKey = `${USER_PREFERENCES_KEY_PREFIX}${userID}`;
    const savedPrefs = getLocalStorage(userPrefsKey);

    if (savedPrefs) {
      try {
        const parsedPrefs = JSON.parse(savedPrefs);
        dispatch(
          loadUserPreferences({
            preferences: {
              theme: parsedPrefs.theme || DEFAULT_THEME,
              landedFacility: parsedPrefs.landedFacility || "",
              requestMonitor: parsedPrefs.requestMonitor || {},
            },
          })
        );
      } catch (error) {
        console.error("Failed to parse user preferences:", error);
        dispatch(loadUserPreferences({ preferences: null }));
      }
    } else {
      dispatch(loadUserPreferences({ preferences: null }));
    }
  };

  const savePreferences = (userID, newPreferences) => {
    if (!userID) {
      return;
    }
    
    const userPrefsKey = `${USER_PREFERENCES_KEY_PREFIX}${userID}`; 
    
    const prefsToSave = {
      theme: newPreferences?.theme || DEFAULT_THEME,
      landedFacility: newPreferences?.landedFacility || "",
    };

    try {

      const existingPrefs = JSON.parse(localStorage.getItem(userPrefsKey)) || {};
      const updatedPrefs = { ...existingPrefs, ...prefsToSave };

      setLocalStorage(userPrefsKey, JSON.stringify(updatedPrefs));
      dispatch(saveUserPreferences({ preferences: newPreferences }));
    } catch (error) {
      console.error("Failed to save user preferences:", error);
    }
  };

  const saveRequestMonitorSearchSettings = (userID, requestMonitorObject) => {
    if (!userID || typeof requestMonitorObject !== 'object') {
      return;
    }
    const userPrefsKey = `${USER_PREFERENCES_KEY_PREFIX}${userID}`;   
    try {
      const existingPrefs = JSON.parse(localStorage.getItem(userPrefsKey)) || { requestMonitor: {} };       
       existingPrefs.requestMonitor = typeof existingPrefs.requestMonitor === 'object'? existingPrefs.requestMonitor : {};
        for (const [entityId, searchSettingPreferences] of Object.entries(requestMonitorObject)) {
        existingPrefs.requestMonitor[entityId] = {
          ...existingPrefs.requestMonitor[entityId],
          ...searchSettingPreferences };
        }
     
       setLocalStorage(userPrefsKey, JSON.stringify(existingPrefs));
       dispatch(saveValetRequestMonitor({ preferences: { requestMonitor: requestMonitorObject }}));
    } catch (error) {
      console.error("Failed to save Request Monitor", error);
    }
  };

  return {
    loadPreferences,
    savePreferences,
    saveRequestMonitorSearchSettings,
  };
};

export default useUserPreferences;
